import { render, staticRenderFns } from "./tableList.vue?vue&type=template&id=130dbc18&scoped=true&"
import script from "./tableList.vue?vue&type=script&lang=js&"
export * from "./tableList.vue?vue&type=script&lang=js&"
import style0 from "./tableList.vue?vue&type=style&index=0&id=130dbc18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130dbc18",
  null
  
)

export default component.exports